var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4223 2.79224C16.4786 1.73592 18.1925 1.73592 19.2488 2.79224L21.2081 4.75063C22.2644 5.80786 22.2644 7.52179 21.2081 8.57811L8.57916 21.2071C8.07129 21.7149 7.38301 22 6.66497 22H2.90244C2.40449 22 2.00037 21.5959 2.00037 21.0979V17.3345C2.00037 16.6174 2.28542 15.9291 2.79328 15.4212L15.4223 2.79224ZM17.9733 4.06854C17.6206 3.71674 17.0505 3.71674 16.6978 4.06854L15.0028 5.76353L18.2376 8.99835L19.9326 7.30336C20.2844 6.95065 20.2844 6.38055 19.9326 6.02784L17.9733 4.06854ZM16.9621 10.2729L13.7273 7.03809L4.06887 16.6965C3.89928 16.8661 3.80457 17.0953 3.80457 17.3343V20.1957H6.66503C6.90498 20.1957 7.1341 20.1009 7.30369 19.9314L16.9621 10.2729Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeService);
export default __webpack_public_path__ + "static/media/ChangeService.5898e8d4e48c06a4eaec65f3eab0307f.svg";
export { ForwardRef as ReactComponent };